import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24737 16138"
    {...props}
  >
    <path
      d="M22367 9127c-1019 854-2560 1194-4466 989 28-38 54-75 82-113 270 24 493 36 696 36 158 0 312-5 461-15 1050-71 1921-391 2590-951 641-538 1055-1269 1222-2144 56-292 84-599 84-922 0-2059-1791-2760-2672-2979 5-75 8-151 11-226 399 59 943 179 1487 414 1241 536 1870 1419 1870 2623 0 1403-472 2540-1365 3288zm-12172 4149c-4840 0-8833-4498-9164-10277 515 205 1243 379 2212 531 1815 283 4225 440 6781 440 2558-1 4967-157 6783-440 1208-189 2051-416 2563-692-259 5871-4253 10438-9175 10438zm8321 125c0 610-3160 1730-8321 1730s-8322-1120-8322-1730c0-247 698-763 2615-1187 1690 1354 3662 2069 5707 2069 2039 0 4009-715 5701-2070 1921 423 2620 941 2620 1188zM10024 1007c4756 0 8028 541 8846 978-817 437-4091 977-8846 977-4754-1-8027-540-8845-977 818-437 4091-978 8845-978zm10248 3040c833 232 1759 761 1759 1960 0 981-327 1774-945 2292-594 497-1427 737-2478 729 864-1488 1436-3203 1664-4981zm113-2269-2-96h-434c-160-392-734-866-3142-1243C14991 155 12582 0 10024 0 7468 0 5058 156 3243 439 810 820 243 1302 92 1701l-89 4-3 537c0 3537 1304 6861 3585 9160-1803 487-2716 1160-2716 1999 0 2165 6099 2737 9326 2737 3226 0 9326-572 9326-2737 0-840-916-1513-2723-2000 129-128 246-251 355-371 635 101 1238 153 1793 153 1682-1 3050-432 4067-1283 1128-946 1723-2351 1723-4061 1-2621-2317-3819-4351-4061z"
      style={{
        fill: "#322d2c",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
